// একটাই জায়গায় ইনভয়েস প্রিন্ট করার HTML — Sales.js-এ সেল কনফার্ম করার সময় যেই প্রিন্ট
// হয়, সেটাই। "View Invoice" যেখানেই খোলে (Due, Contacts, Courier, Reports), সবখানে
// এই একই ফাংশন দিয়ে প্রিন্ট বাটন যোগ করা হয়েছে, যাতে ৪ জায়গায় একই HTML কপি-পেস্ট করে
// রাখতে না হয় এবং ভবিষ্যতে ডিজাইন বদলালে একবারই বদলালেই সব জায়গায় বদলে যায়।
//
// ⚠️ কখনো বেয়ার window.print() কল করবে না -- এই অ্যাপের flex/100vh লেআউটে সরাসরি
// প্রিন্ট করলে পাতা ফাঁকা আসে। তাই সবসময় একটা আলাদা self-contained HTML window খুলে
// সেটাকে প্রিন্ট করানো হয় (CLAUDE.md কনভেনশন #3)।
const formatTk = (num) => new Intl.NumberFormat('en-IN').format(Math.round(num || 0));

// পুরনো কিছু সেল ডকুমেন্টে হয়তো dateTime স্ট্রিং সেভ হয়নি (যদিও Sales.js/WebsiteOrders.js
// সবসময় সেভ করে) -- সেক্ষেত্রে Firestore-এর createdAt টাইমস্ট্যাম্প থেকে একই ফরম্যাটে
// (যেমন "13-September-2026, 06:16 AM") তৈরি করে দেখানো হয়, যাতে তারিখ ফাঁকা না থাকে।
const formatDateTimeFallback = (timestamp) => {
  if (!timestamp) return '';
  const d = timestamp?.toDate ? timestamp.toDate() : new Date(timestamp);
  if (isNaN(d.getTime())) return '';
  const date = d.toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' }).replace(/ /g, '-');
  const time = d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
  return `${date}, ${time}`;
};

// invoice: sales কালেকশনের একটা ডকুমেন্ট (বা Sales.js-এর confirm-এর আগের previewInvoice) --
// দুটোরই শেপ একই, কারণ Firestore-এ ঠিক এই অবজেক্টটাই সেভ হয়।
//
// ⚠️ দোকান নিজে ডেলিভারি চার্জ দিলে (deliveryPaidBy === 'shop') সেই লাইনটা প্রিন্টে
// দেখানো হয় না -- ওটা এমনিতেই গ্রাহকের বিলে (totalBill) যোগ হয়নি, শুধু Kizuna-র নিজের
// খরচ। কুরিয়ারের সাথে যাওয়া বা গ্রাহকের হাতে যাওয়া কাগজে "আমরা এই খরচ বহন করছি" এটা
// জানানোর দরকার নেই, আর এটা দোকানের নিজের খরচের কাঠামো অকারণে প্রকাশ করে দেয়। এই তথ্য
// Sohan নিজে অ্যাপের ভেতরে (View Invoice-এর স্ক্রিন, Accounts, Reports) ঠিকই দেখতে
// পান -- শুধু প্রিন্ট করা কপি থেকে বাদ।
export const printSalesInvoice = (invoice) => {
  if (!invoice) return;
  const printWindow = window.open('', '_blank', 'width=600,height=600');
  if (!printWindow) {
    alert('Print window was blocked by the browser. Please allow popups for this site and try again.');
    return;
  }
  const dateTimeText = invoice.dateTime || formatDateTimeFallback(invoice.createdAt);
  printWindow.document.write(`
    <html>
      <head>
        <title>${invoice.invoiceId}</title>
        <style>
          body { font-family: 'Poppins', sans-serif; padding: 20px; color: #333; }
          .invoice-box { max-width: 400px; margin: auto; padding: 20px; border: 1px solid #eee; box-shadow: 0 0 10px rgba(0,0,0,0.1); font-size: 12px; }
          table { width: 100%; border-collapse: collapse; margin-top: 10px; }
          th, td { padding: 5px; text-align: left; border-bottom: 1px solid #eee; }
          .text-right { text-align: right; }
          .text-center { text-align: center; }
        </style>
      </head>
      <body>
        <div class="invoice-box">
          <div style="text-align:center; margin-bottom:15px;">
            <h2 style="margin:0; color:#4a00e0; font-size:18px;">PB KIZUNA COMPANY LIMITED</h2>
            <p style="margin:4px 0; font-size:10px;">H-10, R-2, Section-2, Block-D, Aftabnagar, Dhaka</p>
            <p style="margin:0; font-size:10px;">Mobile: 01884-711844</p>
            <hr style="border: dashed 1px #000; margin: 10px 0;"/>
            <h4 style="margin:0; font-size:12px;">SALES INVOICE</h4>
          </div>
          <table style="width:100%; border-collapse:collapse;">
            <tr>
              <td style="vertical-align:top; width:50%; padding-right:8px;">
                <p style="margin: 2px 0;"><b>Sold By:</b> ${invoice.soldBy || ''}</p>
                <p style="margin: 2px 0;"><b>Date:</b> ${dateTimeText}</p>
                <p style="margin: 2px 0;"><b>Invoice ID:</b> #${invoice.invoiceId}</p>
              </td>
              <td style="vertical-align:top; width:50%; border:1px solid #ddd; border-radius:6px; padding:8px 10px; background:#f8f9ff;">
                <p style="margin:0 0 4px 0; font-weight:bold; color:#4a00e0;">Bill To</p>
                <p style="margin: 2px 0;">${invoice.name || invoice.customerName || 'Walk-in Customer'}</p>
                ${[invoice.phone, invoice.phone2].filter(Boolean).length > 0 ? `<p style="margin: 2px 0;">${[invoice.phone, invoice.phone2].filter(Boolean).join(', ')}</p>` : ''}
                ${invoice.address ? `<p style="margin: 2px 0;">${invoice.address}</p>` : ''}
              </td>
            </tr>
          </table>
          <hr style="border: dashed 1px #000; margin: 10px 0;"/>
          <table>
            <thead>
              <tr>
                <th>ITEM</th>
                <th class="text-center">QTY</th>
                <th class="text-right">TOTAL</th>
              </tr>
            </thead>
            <tbody>
              ${(invoice.items || []).map(it => `
                <tr>
                  <td><b>${it.name}</b> ${it.itemDiscAmount > 0 ? `<br/><span style="font-size:10px; color:red;">Disc: -৳ ${formatTk(it.itemDiscAmount)}</span>` : ''}</td>
                  <td class="text-center">${it.qty}</td>
                  <td class="text-right">${formatTk(it.finalItemTotal)}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
          <div style="margin-top:15px; text-align:right; font-size:12px;">
            <p style="margin:2px 0;">Sub Total: ৳ ${formatTk(invoice.subtotal)}</p>
            ${invoice.totalDiscount > 0 ? `<p style="margin:2px 0; color:red;">Total Discount: -৳ ${formatTk(invoice.totalDiscount)}</p>` : ''}
            ${(invoice.deliveryCharge > 0 && invoice.deliveryPaidBy !== 'shop')
              ? `<p style="margin:2px 0;">Delivery Charge: +৳ ${formatTk(invoice.deliveryCharge)}</p>`
              : ''}
            <h3 style="margin:5px 0; font-size:14px;">Grand Total: ৳ ${formatTk(invoice.totalBill)}</h3>
            <p style="margin:2px 0;">${invoice.deliveryMethod === 'courier' ? 'Advance Paid' : 'Paid'}${Number(invoice.paid || 0) > 0 ? ` (${invoice.paidMethod || 'Cash'})` : ''}: ৳ ${formatTk(invoice.paid)}</p>
            ${Number(invoice.dueAmount || 0) > 0
              ? (invoice.deliveryMethod === 'courier'
                  // কুরিয়ার সেলের প্রিন্টটা পার্সেলের সাথে কাস্টমারের কাছে যায় -- সেখানে
                  // "Due" লিখলে মনে হবে সে টাকা মেরে দিয়েছে, আসলে ডেলিভারিতে দিবে।
                  ? `<p style="margin:2px 0; color:#b45309; font-weight:bold;">Cash on Delivery: ৳ ${formatTk(invoice.dueAmount)}</p>`
                  : `<p style="margin:2px 0; color:red; font-weight:bold;">Due: ৳ ${formatTk(invoice.dueAmount)}</p>`)
              : (Number(invoice.returnAmount || 0) > 0
                  ? `<p style="margin:2px 0;">Return: ৳ ${formatTk(invoice.returnAmount)}</p>`
                  : `<p style="margin:2px 0; font-weight:bold;">Fully Paid</p>`)
            }
          </div>
          <p style="text-align:center; margin-top:20px; font-weight:bold; font-size:11px;">Thank you, come again!</p>
        </div>
        <script>
          document.title = "${invoice.invoiceId}";
          window.onload = function() {
            window.print();
          }
        </script>
      </body>
    </html>
  `);
  printWindow.document.close();
};
